var Method = {
  None: 'none',
  SetLocale: 'setLocale',
};

// class Response {
//   constructor(result, secondResult, errorCode) {
//     this.result = result || '';
//     this.secondResult = secondResult || '';
//     this.errorCode = errorCode || '';
//   }
//   getResult() {
//     return this.result;
//   }
//   getSecondResult() {
//     return this.secondResult;
//   }
//   getErrorCode() {
//     return this.errorCode;
//   }
//   isOk() {
//     return this.errorCode === 'NONE';
//   }
//   isPasswordAttemptsError() {
//     return this.isPasswordError() && +this.result > -1;
//   }
//   isPasswordError() {
//     return this.errorCode === 'WRONG_PASSWORD';
//   }
//   isKeyTypeError() {
//     return this.errorCode === 'EMPTY_KEY_LIST';
//   }
//   isRdnNotFoundError() {
//     return this.errorCode === 'RDN_NOT_FOUND';
//   }
//   isXmlParseError() {
//     return this.errorCode === 'XML_PARSE_EXCEPTION';
//   }
//   isSignatureValidationError() {
//     return this.errorCode === 'SIGNATURE_VALIDATION_ERROR';
//   }
//   isCommonError() {
//     return this.errorCode === 'COMMON';
//   }
//   isKeyStoreError() {
//     return this.errorCode === 'LOAD_KEYSTORE_ERROR';
//   }
//   isUnknownStorageError() {
//     return this.errorCode === 'UNKNOWN_STORAGE';
//   }
//   isFileReadError() {
//     return this.errorCode === 'FILE_READ_ERROR';
//   }
// }

class Client {
  constructor(ws) {
    this.err = {message: ''};
    this.method = Method.None;
    this.version = '';
    if (ws) {
      this.cb = (resp) => {
        const data = JSON.parse(resp);
        const _a = data.result || null;

        this.version =
          _a === null || _a === void 0 ? void 0 : _a.version;
      };
      this.ws = ws;
      this.ws.onmessage = (e) => {
        // Skip this because setLocale returns nothing.
        if (this.method === Method.SetLocale) {
          return;
        }

        this.cb(e.data);
      };
      return;
    }
    this.err = {message: 'init: websocket instance is null or undefined'};
  }
  readyState() {
    return this.ws.readyState;
  }
  close() {
    this.ws.close();
  }
  hasError() {
    var _a;
    return ((_a = this.err) === null || _a === void 0 ? void 0 : _a.message) != '';
  }
  getError() {
    return this.err;
  }
  send(data, callback) {
    // Return none if client has error.
    if (this.hasError()) {
      return Method.None;
    }
    this.method = data.method;
    this.cb = callback;
    this.ws.send(JSON.stringify(data));
  }
}

export default Client;
